import { render, staticRenderFns } from "./TopUpCredits.vue?vue&type=template&id=1498e7b9&scoped=true&"
import script from "./TopUpCredits.vue?vue&type=script&lang=js&"
export * from "./TopUpCredits.vue?vue&type=script&lang=js&"
import style0 from "./TopUpCredits.vue?vue&type=style&index=0&id=1498e7b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1498e7b9",
  null
  
)

export default component.exports